import type { PropType } from 'vue';
import { type ComponentSizes, componentDefaultSize } from '../../constants';

export type StatusColor = 'green' | 'grey' | 'red' | 'purple' | 'orange' | 'pink' | 'turquoise' | 'blue' | 'yellow' | 'violet';
export type StatusColorType = 'light' | 'dark';
export type StatusRounded = 'large' | 'medium' | 'small' | 'extra-small';

type LegacyStatusColor = '' | 'green' | 'red' | 'magenta' | 'brown' | 'purple' | 'orange' | 'yellow' | 'mint' | 'blue' | 'darkblue' | 'carbon-gray';

const LEGACY_COLOR_MAP: Partial<Record<LegacyStatusColor, StatusColor>> = {
    green: 'green',
    red: 'red',
    magenta: 'pink',
    brown: 'grey',
    purple: 'purple',
    orange: 'orange',
    yellow: 'yellow',
    mint: 'turquoise',
    blue: 'blue',
    darkblue: 'violet',
    'carbon-gray': 'grey',
};

const ALLOWED_COLORS: StatusColor[] = [
    'green',
    'grey',
    'red',
    'purple',
    'orange',
    'pink',
    'turquoise',
    'blue',
    'yellow',
    'violet',
];

export const resolveStatusColor = (color: string | undefined): StatusColor | undefined => {
    if (!color) return undefined;
    const mapped = LEGACY_COLOR_MAP[color as LegacyStatusColor];
    if (mapped) return mapped;
    return ALLOWED_COLORS.includes(color as StatusColor) ? (color as StatusColor) : undefined;
};

export interface StatusProps {
    text?: string;
    color?: string;
    colorType?: StatusColorType;
    size?: ComponentSizes;
    isShadow?: boolean;
    rounded?: StatusRounded;
}

export const statusProps = {
    text: {
        type: String as PropType<StatusProps['text']>,
        default: undefined,
        required: false,
    },
    color: {
        type: String as PropType<StatusProps['color']>,
        default: 'green',
        required: false,
    },
    colorType: {
        type: String as PropType<StatusProps['colorType']>,
        default: 'light',
        required: false,
    },
    size: {
        type: String as PropType<StatusProps['size']>,
        default: componentDefaultSize,
        required: false,
    },
    isShadow: {
        type: Boolean as PropType<StatusProps['isShadow']>,
        default: false,
        required: false,
    },
    rounded: {
        type: String as PropType<StatusProps['rounded']>,
        default: undefined,
        required: false,
    },
};
